import { useCallback, useSyncExternalStore } from 'react';

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** Smartphone layout (breakpoint `sm`, below 640 px, docs/ui/responsive.md). */
export function useIsPhone(): boolean {
  return useMediaQuery('(max-width: 39.99rem)');
}

/** Desktop layout (breakpoint `lg`, from 1024 px). */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 64rem)');
}
